// extracted by mini-css-extract-plugin
module.exports =  {"content":"copy_button-module_content_cfb16","tooltip":"copy_button-module_tooltip_bff63"};